import AppRoutes from './routes';

interface ITextParams {
  isRFQ: boolean | null;
}

export enum Pages {
  ProductManager = 'product-manager',
  OrderRfqManager = 'order-rfq-manager',
  Analytics = 'analytics',
  Settings = 'settings',
}

const pages = [
  {
    id: Pages.ProductManager,
    route: AppRoutes.ProductManager,
    text: 'Product Manager',
  },
  {
    id: Pages.OrderRfqManager,
    route: AppRoutes.OrderManager,
    render: ({ isRFQ }: ITextParams) => {
      if (isRFQ === null) return 'Order / RFQ Manager';
      return isRFQ ? 'RFQ Manager' : 'Order Manager';
    },
    text: 'Order / RFQ Manager',
  },
  {
    id: Pages.Analytics,
    route: AppRoutes.Analytics,
    text: 'Analytics',
  },
  {
    id: Pages.Settings,
    route: AppRoutes.Settings,
    text: 'Settings',
  },
];

export default pages;
